import getCurrentModuleBasePathWithSearchQuery from 'mini-common-utils/lib/utils/getCurrentModuleBasePathWithSearchQuery';
import { goBackInBrowserHistory } from './historyUtils';

const ROUTE_CHANGE_TIMEOUT = 300;

export function historyBackWithFallbackUrl(step = -1, fallbackUrl = '/'): void {
    const prevPageUrl = window.location.href;

    goBackInBrowserHistory(step > 0 ? -step : step);

    setTimeout(function () {
        if (window.location.href === prevPageUrl) {
            window.location.href = fallbackUrl;
        }
    }, ROUTE_CHANGE_TIMEOUT);
}

export function historyBackWithModuleLevelFallbackUrl(step = -1): void {
    historyBackWithFallbackUrl(step, getCurrentModuleBasePathWithSearchQuery());
}
